import { translateFromEnglish } from 'marketing-site/lib/translation/translate'
import TranslationsContext from 'marketing-site/src/components/context/TranslationsContext'
import { useCallback, useContext } from 'react'
import getValidationErrorIfAny, {
  getValidationErrorWithCallback,
} from '../elements/Form/utils/getValidationErrorIfAny'

/**
 * Returns object with named function translate(text) which returns translated text from TranslationsContext
 * @returns translate(text: string) => translatedText: string
 */
export default function useTranslate() {
  const translationsMap = useContext(TranslationsContext)

  const translate = useCallback(
    (text: string): string => translateFromEnglish(text, translationsMap),
    [],
  )

  const getTranslatedValidationErrorIfAny = <F extends typeof getValidationErrorIfAny>(
    ...args: Parameters<F>
  ): Promise<string> => {
    const _args: Parameters<typeof getValidationErrorIfAny> = args
    return getValidationErrorIfAny(..._args).then(translate)
  }

  const getTranslatedValidationErrorWithCallback = <
    F extends typeof getValidationErrorWithCallback,
  >(
    ...args: Parameters<F>
  ): Promise<string> => {
    const _args: Parameters<typeof getValidationErrorWithCallback> = args
    return getValidationErrorWithCallback(..._args).then(translate)
  }

  return {
    translate,
    getTranslatedValidationErrorIfAny,
    getTranslatedValidationErrorWithCallback,
  }
}
